export type ConsentCategoryConfig = {
  id: 'preferences' | 'analytics' | 'advertising';
  label: string;
  description: string;
};

export const ESSENTIAL_CATEGORY = {
  label: 'Necessary',
  description:
    'Necessary cookies help make a website usable by enabling basic functions like page navigation and access to secure areas of the website. The website cannot function properly without these cookies.',
};

export const CATEGORIES: ConsentCategoryConfig[] = [
  {
    id: 'preferences',
    label: 'Preferences',
    description:
      'Preference cookies enable a website to remember information that changes the way the website behaves or looks, like your recent searches or your saved delivery details.',
  },
  {
    id: 'analytics',
    label: 'Statistics',
    description:
      'Statistic cookies help website owners understand how visitors interact with websites by collecting and reporting information, including pharmacy products interaction.',
  },
  {
    id: 'advertising',
    label: 'Marketing',
    description:
      'Marketing cookies are used to track visitors across websites. The intention is to display ads that are relevant and engaging for the individual user and thereby more valuable for publishers and third party advertisers.',
  },
];

export const DEFAULT_PREFERENCES = {
  preferences: false,
  analytics: false,
  advertising: false,
};
